export default __webpack_public_path__ + "static/media/muhharam_1.01aaffd6.jpg";